import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getProductAdminOverview () {
    return Api()
      .get('v1/admin/productManagement')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.GetProductAdminErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getAdminPrices (productUid) {
    var url = '/v1/admin/productManagement/' + productUid + '/Prices'
    return Api()
      .get(url)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.GetPricesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async create (product) {
    return Api()
      .post('v1/admin/productManagement', {
        uid: '00000000-0000-0000-0000-000000000000',
        name: product.name,
        vendorId: product.vendorId,
        contentNodeId: product.contentNodeId,
        published: product.published,
        availableLanguageCodes: product.availableLanguageCodes,
        daysTrial: product.daysTrial,
        coterminationAllowed: product.coterminationAllowed,
        displayTemplateAlias: product.displayTemplateAlias,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.CreateProductSuccessMessage', [product.name]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.CreateProductErrorMessage', [product.name]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async update (product) {
    var updatedProduct = {
      uid: product.uid,
      name: product.name,
      vendorId: product.vendorId,
      contentNodeId: product.contentNodeId,
      published: product.published,
      variants: product.variants,
      availableLanguageCodes: product.availableLanguageCodes,
      daysTrial: product.daysTrial,
      coterminationAllowed: product.coterminationAllowed,
      displayTemplateAlias: product.displayTemplateAlias,
    }

    return Api()
      .put('v1/admin/productManagement', updatedProduct)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.UpdateProductSuccessMessage', [product.name]),
          color: 'success',
        })
        return { success: true, value: updatedProduct }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.UpdateProductErrorMessage', [product.name]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async deleteProduct (productUid) {
    return Api()
      .delete('v1/admin/productManagement/' + productUid)
      .then(function () {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.DeleteProductSuccessMessage'),
          color: 'success',
        })
        return { success: true }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.DeleteProductErrorMessage', [productUid.substr(0, 6)]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async createPrice (priceItem) {
    return Api()
      .post('v1/admin/productManagement/' + priceItem.productUid + '/price', {
        uid: '00000000-0000-0000-0000-000000000000',
        productUid: priceItem.productUid,
        tierQuantity: priceItem.tierQuantity,
        price: priceItem.price,
        mSRP: priceItem.msrp,
        resellerUid: priceItem.resellerUid,
        productVariantUid: priceItem.productVariantUid,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.CreatePriceSuccessMessage'),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.CreatePriceErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async deletePrice (priceDeleteItem) {
    return Api()
      .delete('v1/admin/productManagement/' + priceDeleteItem.productUid + '/price?priceItemUid=' + priceDeleteItem.priceUid)
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.DeletePriceSuccessMessage'),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.DeletePriceErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async updatePrices (productUid, prices) {
    var updatedPrices = prices.map(priceItem => {
      return {
        uid: priceItem.uid,
        productUid: productUid,
        tierQuantity: priceItem.tierQuantity,
        price: parseFloat(priceItem.currentPrice),
        mSRP: parseFloat(priceItem.currentMsrp),
        resellerUid: priceItem.newResellerUid,
        productVariantUid: priceItem.newProductVariantUid || priceItem.productVariantUid,
      }
    })

    return Api()
      .post('v1/admin/productManagement/' + productUid + '/prices', updatedPrices)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.UpdatePricesSuccessMessage'),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Product.Messages.UpdatePricesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async revokeResellerPrices (resellerDetails) {
    var revokeResellersEndpoint = 'v1/admin/productManagement/' + resellerDetails.productUid + '/prices?resellerUid=' + resellerDetails.resellerUid
    if (resellerDetails.productVariantUid) {
      revokeResellersEndpoint += '&productVariantUid=' + resellerDetails.productVariantUid
    }

    return Api()
    .delete(revokeResellersEndpoint)
    .then(async function (response) {
      await Store.dispatch('SetSnackBarMessage', {
        message: i18n.t('Services.Admin.Product.Messages.RevokeResellerPricesSuccessMessage'),
        color: 'success',
      })
      return { success: true, value: response.data }
    })
    .catch(async function (error) {
      await Store.dispatch('SetSnackBarMessage', {
        message: i18n.t('Services.Admin.Product.Messages.RevokeResellerPricesErrorMessage'),
        color: 'error',
      })
      console.error(error)
      return { success: false }
    })
  },
}
